<template>
  <info-container title="Stats">
    <div v-if="summary" class="tw-mt-3">
      <table>
        <thead>
          <tr>
            <th>Status</th>
            <th>Aantal</th>
          </tr>
        </thead>
        <tbody class="tw-mt-3">
          <tr v-show="viewMode === 'installation'">
            <td class="tw-w-32 tw-p-1" :class="statuses.created">created</td>
            <td>{{ summary.created }} / {{ summary.createdPercentage }}%</td>
          </tr>
          <tr>
            <td class="tw-w-32 tw-p-1" :class="statuses.approved">approved</td>
            <td>{{ summary.approved }} / {{ summary.approvedPercentage }}%</td>
          </tr>
          <tr>
            <td class="tw-w-32 tw-p-1" :class="statuses.assigned">assigned</td>
            <td>{{ summary.assigned }} / {{ summary.assignedPercentage }}%</td>
          </tr>
          <tr>
            <td class="tw-w-32 tw-p-1" :class="statuses.cancelled">cancelled</td>
            <td>{{ summary.cancelled }} / {{ summary.cancelledPercentage }}%</td>
          </tr>

          <tr>
            <td class="tw-w-32 tw-p-1">Totaal</td>
            <td>{{ summary.total }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </info-container>
</template>

<script setup>
import { computed } from 'vue'
import InfoContainer from '@/components/shared/InfoContainer.vue'

const props = defineProps({
  building: Object,
  viewMode: {
    type: String,
    default: 'sales',
  },
  statuses: {
    type: Object,
  },
})

const building = computed(() => props.building)
const viewMode = computed(() => props.viewMode)

const summary = computed(() => {
  if (!building.value) return null

  const summary = {
    total: building.value.locations.length,
    approved: building.value.locations.filter(
      (loc) => loc.status[viewMode.value]?.status === 'approved'
    ).length,
    assigned: building.value.locations.filter(
      (loc) => loc.status[viewMode.value]?.status === 'assigned'
    ).length,
    cancelled: building.value.locations.filter(
      (loc) => loc.status[viewMode.value]?.status === 'cancelled'
    ).length,
    created: building.value.locations.filter(
      (loc) => loc.status[viewMode.value]?.status === 'created'
    ).length,
  }

  summary.approvedPercentage = Math.round((summary.approved / summary.total) * 100)
  summary.assignedPercentage = Math.round((summary.assigned / summary.total) * 100)
  summary.cancelledPercentage = Math.round((summary.cancelled / summary.total) * 100)
  summary.createdPercentage = Math.round((summary.created / summary.total) * 100)

  return summary
})
</script>
